module.exports = __webpack_public_path__ + "fonts/la-brands-400.bbf83f8.ttf";